import url from './urls'

const state = {
  data: null,
  isLoading: false
}

const mutations = {
  GET (state) {
    state.isLoading = true

    fetch(url.sponsor)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.data = data.data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  }
}

const actions = {
  get ({ commit }) {
    commit('GET')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
